// @givmo/design-system — Skeleton (SaaS layer).
//
// A shimmer placeholder block for loading states (table rows, cards, stat values). A neutral-100
// base with a slow pulse; pass `w`/`h`/`rounded` via className. `SkeletonText` renders N lines.
import type { HTMLAttributes } from 'react';
import { cn } from '../lib/utils';
import { testIdProp, type TestIdProps } from '../lib/testid';

export interface SkeletonProps extends HTMLAttributes<HTMLDivElement>, TestIdProps {}

export function Skeleton({ className, testId, ...props }: SkeletonProps) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-neutral-150', className)}
      aria-hidden
      {...testIdProp(testId)}
      {...props}
    />
  );
}

export interface SkeletonTextProps extends TestIdProps {
  /** Number of lines to render (default 3). */
  lines?: number;
  className?: string;
}

export function SkeletonText({ lines = 3, className, testId }: SkeletonTextProps) {
  return (
    <div className={cn('flex flex-col gap-8', className)} {...testIdProp(testId)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} className={cn('h-12', i === lines - 1 ? 'w-2/3' : 'w-full')} />
      ))}
    </div>
  );
}
